import React, { useContext, useState } from 'react';
import {
  CrudContext,
  usePromise,
  Widget,
  FormatText,
  MasterDetailForm,
  FormSubmitButton,
  FormInput,
  FormDatePicker,
  InlineEditTable,
  FormSwitch,
  ColumnType,
  Table,
  Button,
} from '@digital/ui';
import {
  getAllDocumentacaoAcessoriaByContrato,
  createDocumentacaoAcessoria,
  updateDocumentoAcessorioAplicabilidade,
} from '@app/api/contrato/documentacaoAcessoria';
import { Collapse, Icon } from 'antd';
import * as Yup from 'yup';
import { hasPermission } from '@app/helpers/permissions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { creatDocumentoAcessoriaByContratoId } from '@app/api/contrato';

interface DocumentoAcessoriaProps {
  onUpdate: () => any;
  atualizar: boolean;
}

const DocumentacaoComplementarLocal = (props: DocumentoAcessoriaProps) => {
  const { onUpdate, atualizar } = props;

  const [updateList, setUpdateList] = useState();
  const [initialValueForm, setinitialValueForm] = useState();

  const { selectedItem } = useContext(CrudContext);
  const [documentacoesAcessoria] = usePromise(
    () => (selectedItem ? getAllDocumentacaoAcessoriaByContrato(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem, updateList, atualizar],
    [],
  );

  const submitCreateSeguroGarantia = (values: any) =>
    createDocumentacaoAcessoria(selectedItem.id, values).then(() => {
      setUpdateList(false);
      setUpdateList(true);
      setinitialValueForm({ nome: '  ', dataValidade: '  ' });
      setinitialValueForm({ nome: '', dataValidade: '' });
    });

  const columns = [
    {
      title: 'Documento',
      dataIndex: 'nome',
      editable: { inputType: 'text' },
      width: '55%',
    },
    {
      title: 'Aplicável',
      dataIndex: 'aplicavel',
      type: ColumnType.Switch,
      renderEdit: () => <FormSwitch name="aplicavel" />,
      width: '10%',
    },
    {
      title: 'Validade',
      dataIndex: 'dataValidade',
      type: ColumnType.Date,
      renderEdit: () => <FormDatePicker name="dataValidade" format="DD/MM/YYYY" />,
      width: '20%',
    },
  ];

  const { Panel } = Collapse;

  return (
    <>
      {selectedItem.possuiDocumentacaoAcessoria && hasPermission(['CONTRATO_DOC_ACESSORIA_CADASTRAR_COMPLEMENTAR']) && (
        <Collapse bordered={false} defaultActiveKey={['novoItem']} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel
            key="novoItem"
            header={'Cadastro de Documento Acessório Complementar' || <FormatText id="ui.commons.filter" camelcase />}
            style={{ border: 0 }}>
            <MasterDetailForm
              onSubmit={submitCreateSeguroGarantia}
              initialValues={initialValueForm}
              validationSchema={Yup.object().shape({
                nome: Yup.string()
                  .required('Nome deve ser informado')
                  .max(200, 'Nome deve ter no máximo 200 caracteres'),
              })}>
              <Widget
                className="ant-app-actions-widget"
                actions={[
                  <Button
                    type="link"
                    icon="calendar-crossed_out_date"
                    title="Gerar Doc. Acessória"
                    onClick={() => {
                      if (selectedItem) {
                        creatDocumentoAcessoriaByContratoId(selectedItem.id).then(() => {
                          onUpdate();
                        });
                      }
                    }}
                  />,
                  <FormSubmitButton noIcon={true} className="btn-primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>,
                ]}>
                <FormInput label="Nome" name="nome" span={4} />
                <FormDatePicker format="DD/MM/YYYY" label="Data de Validade" name="dataValidade" span={4} />
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>
      )}
      <Collapse
        bordered={false}
        defaultActiveKey={['tableDocumentosComplementarOficial']}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel
          key="tableDocumentosComplementarOficial"
          header={
            'Documentação Acessória de Contrato (Oficial e Complementar)' || (
              <FormatText id="ui.commons.filter" camelcase />
            )
          }
          style={{ border: 0 }}>
          <Widget>
            {hasPermission(['CONTRATO_DOC_ACESSORIA_INDICAR_NAO_APLICABILIDADE']) ? (
              <PerfectScrollbar>
                <InlineEditTable
                  columns={columns}
                  dataSource={documentacoesAcessoria}
                  updateItem={updateDocumentoAcessorioAplicabilidade}
                  pagination={false}
                />
              </PerfectScrollbar>
            ) : (
              <PerfectScrollbar>
                <Table columns={columns} dataSource={documentacoesAcessoria} pagination={false} />
              </PerfectScrollbar>
            )}
          </Widget>
        </Panel>
      </Collapse>
    </>
  );
};

export default DocumentacaoComplementarLocal;
